<template>
	<div>
		<RadioGroup
			v-model="type"
			:options="typeOptions"
			@change="emitChangeEvent"
		/>
		<FormGroup v-if="itemsEligible" label="Wähle aus, was für dich in Ordnung wäre:" class="mt-4">
			<SelectInline
				v-model="items"
				multiple
				initial-show-all
				:characteristic-items="characteristicItems"
				label-type="application"
				@input="emitChangeEvent"
			/>
		</FormGroup>
	</div>
</template>

<script>
import RadioGroup from "@/vue/common/form/RadioGroup.vue";
import {hasNotTag} from "@/helper/characteristic/Filter";
import {APPLICATION_INVISIBLE} from "@/helper/characteristic/Tag";
import SelectInline from "@/vue/characteristic/SelectInline.vue";
import FormGroup from "@/vue/common/form/Group.vue";
import {mapState} from "vuex";
import {isDefined} from "@/helper/Value";
import {arrayIsNotEmpty} from "@/helper/Array";
import * as Parking from "@/helper/application/Parking"

export default {

	components: {
		RadioGroup,
		FormGroup,
		SelectInline
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {
			type: this.value?.type,
			typeOptions: Object.freeze([
				{value: Parking.TYPE_IRRELEVANT, text: Parking.getLabel(Parking.TYPE_IRRELEVANT)},
				{value: Parking.TYPE_YES, text: Parking.getLabel(Parking.TYPE_YES)},
				{value: Parking.TYPE_NO, text: Parking.getLabel(Parking.TYPE_NO)},
			]),
			items: this.value?.items,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		itemsEligible ()
		{
			return this.type === Parking.TYPE_YES;
		},
		characteristicItems ()
		{
			return hasNotTag(this.meta.parking, APPLICATION_INVISIBLE);
		},
		valid ()
		{
			if (this.type === undefined)
			{
				return false;
			}

			if (!this.itemsEligible)
			{
				return true;
			}

			return isDefined(this.items) && arrayIsNotEmpty(this.items);
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.valid)
			{
				this.$emit('input', undefined);

				return;
			}

			this.$emit('input', {
				type: this.type,
				items: this.itemsEligible
					? this.items
					: undefined,
			});
		},
	}
}
</script>
